import React from "react";
import OPIContent from "../components/opi/opi-content";

const OPI = () => {
  return <OPIContent />;
};

export default OPI;
